
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import { useNotifications } from '@/context/NotificationContext';

// Your actual Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDNy0MurMBxYCv40Zd6J8QSewe_xMPrLcQ",
  authDomain: "fimdreactnative.firebaseapp.com",
  projectId: "fimdreactnative",
  storageBucket: "fimdreactnative.firebasestorage.app",
  messagingSenderId: "349932318363",
  appId: "1:349932318363:web:3d40cd35049e083cf7203e"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// We'll initialize messaging only if it's supported
let messaging: any = null;

// Initialize messaging if supported
const initializeMessagingIfSupported = async () => {
  try {
    const isMessagingSupported = await isSupported();
    if (isMessagingSupported) {
      messaging = getMessaging(app);
      console.log('Firebase messaging is supported in this browser');
      return true;
    } else {
      console.warn('Firebase messaging is not supported in this browser');
      return false;
    }
  } catch (error) {
    console.error('Error checking messaging support:', error);
    return false;
  }
};

// Request permission and get FCM token
export const requestNotificationPermission = async () => {
  try {
    console.log('Requesting notification permission...');
    
    // First check if messaging is supported
    const isSupported = await initializeMessagingIfSupported();
    if (!isSupported) {
      console.error('Messaging is not supported in this browser');
      return { 
        token: null, 
        permissionGranted: false, 
        error: 'Messaging not supported in this browser' 
      };
    }
    
    // Then request permission
    const permission = await Notification.requestPermission();
    console.log('Permission result:', permission);
    
    if (permission === 'granted') {
      console.log('Notification permission granted.');
      const result = await getMessagingToken();
      return { 
        token: result.token, 
        permissionGranted: true, 
        error: result.error 
      };
    } else {
      console.log('Unable to get permission to notify.');
      return { 
        token: null, 
        permissionGranted: false, 
        error: 'Permission denied' 
      };
    }
  } catch (error) {
    console.error('Error requesting permission:', error);
    return { 
      token: null, 
      permissionGranted: false, 
      error: `${error}` 
    };
  }
};

// Get FCM token
export const getMessagingToken = async () => {
  try {
    if (!messaging) {
      console.error('Messaging is not initialized');
      return { token: null, error: 'Messaging not initialized' };
    }
    
    // Using your VAPID key
    const currentToken = await getToken(messaging, {
      vapidKey: 'BARYnnG3jwPcIRIFUnQgqTy8OhQmBJJ9QFI_nZ34T4V9xMhBLbUTAm8XZIBKgcF6mF49zIozhttSho7iNRSzWOg'
    });
    
    if (currentToken) {
      console.log('Current token:', currentToken);
      return { token: currentToken, error: null };
    } else {
      console.log('No registration token available.');
      return { token: null, error: 'No registration token available' };
    }
  } catch (error) {
    console.error('Error getting token:', error);
    return { token: null, error: `${error}` };
  }
};

// Set up message listener
export const setupMessageListener = (addNotification: (notification: any) => void) => {
  if (!messaging) {
    console.error('Messaging is not initialized');
    return () => {};
  }
  
  return onMessage(messaging, (payload) => {
    console.log('Message received:', payload);
    
    // Process and add the notification
    if (payload.notification) {
      addNotification({
        title: payload.notification.title || 'New Notification',
        body: payload.notification.body || 'You have a new notification',
      });
    }
  });
};

// Create a hook for Firebase Messaging
export const useFirebaseMessaging = () => {
  const { addNotification } = useNotifications();
  
  const initializeMessaging = async () => {
    const result = await requestNotificationPermission();
    if (result.token) {
      // Set up listener for incoming messages
      setupMessageListener(addNotification);
    }
    return result;
  };
  
  return { initializeMessaging };
};
